import React from "react";
import { heroImages, heroData } from "@/data/mock";

const HeroSection = () => {
  const taglineRepeated = `${heroData.tagline} \u00b7 ${heroData.tagline} \u00b7 ${heroData.tagline} \u00b7 `;

  return (
    <section className="relative h-screen overflow-hidden">
      {/* Image Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 h-full">
        {/* Col 1 - tall single image */}
        <div className="overflow-hidden">
          <img
            src={heroImages[0]}
            alt="Travel cinematic"
            className="w-full h-full object-cover scale-105"
            loading="eager"
          />
        </div>
        {/* Col 2 - two stacked images */}
        <div className="flex flex-col">
          <div className="flex-1 overflow-hidden">
            <img
              src={heroImages[1]}
              alt="Drone aerial"
              className="w-full h-full object-cover scale-105"
              loading="eager"
            />
          </div>
          <div className="flex-1 overflow-hidden">
            <img
              src={heroImages[2]}
              alt="Golden hour"
              className="w-full h-full object-cover scale-105"
              loading="eager"
            />
          </div>
        </div>
        {/* Col 3 - tall single image (hidden on mobile) */}
        <div className="hidden md:block overflow-hidden">
          <img
            src={heroImages[3]}
            alt="Beach aerial"
            className="w-full h-full object-cover scale-105"
            loading="eager"
          />
        </div>
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Scrolling Text Banner */}
      <div className="absolute top-20 sm:top-24 md:top-28 w-full overflow-hidden">
        <div className="animate-marquee whitespace-nowrap">
          <span className="font-inter text-[10px] md:text-xs text-white/30 tracking-[0.3em] uppercase">
            {taglineRepeated}
            {taglineRepeated}
          </span>
        </div>
      </div>

      {/* Center Title */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
        <h1 className="font-bebas text-[2.8rem] sm:text-[4rem] md:text-[7rem] lg:text-[9rem] xl:text-[11rem] text-white tracking-[0.1em] leading-[0.9]">
          ANKIT MOHANTY
        </h1>
        <p className="font-inter text-white/50 text-[10px] sm:text-xs md:text-sm tracking-[0.2em] sm:tracking-[0.3em] uppercase mt-3 md:mt-6">
          {heroData.title}
        </p>
        <p className="font-playfair italic text-[#D4C5A9] text-sm sm:text-base md:text-xl lg:text-2xl tracking-wide mt-4 md:mt-7 max-w-2xl leading-relaxed px-4">
          Turning places into stories that are felt deeply, remembered, and truly lived
        </p>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#1A1A1A] to-transparent" />
    </section>
  );
};

export default HeroSection;
